var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37,
    height: 50,
    viewBox: "0 0 37 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.741,
    cy: 45.649,
    fill: "#000",
    opacity: 0.181,
    rx: 10.718,
    ry: 4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#43B542",
    stroke: "#43B542",
    d: "M18.5.5c4.969 0 9.466 2.083 12.722 5.449 3.262 3.372 5.278 8.03 5.278 13.175 0 5.767-2.533 10.923-6.515 14.34h0L19.981 43.808c-.396.408-.92.618-1.447.627-.525.009-1.053-.182-1.46-.574h0L7.013 33.465C3.035 30.047.5 24.89.5 19.124c0-5.145 2.016-9.803 5.278-13.175C9.034 2.583 13.53.5 18.5.5z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.f9acecf2815e4a81561ffd5016c8e3f6.svg";
export { ForwardRef as ReactComponent };